import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
`;

export const ContentContainer = styled.div`
    display: block;
    min-height: 500px;
    overflow-y: auto;
    padding: 15px;
    @media (max-width: 575px) {
        padding: 15px 5px;
    }
`;

export const Header = styled.div`   
    align-items: center;
    background-color: ${ ({ theme: { grayBackground } }) => grayBackground };
    border-bottom: 1px solid ${ ({ theme: { secondaryColor } }) => secondaryColor };
    display: flex;
    font-size: 14px;
    height: 30px;
    justify-content: space-between;
    padding: 10px;
    width: 100%;
    @media print {
        display: none;
    }
`;

export const RightActionTitle = styled.span`
    color: ${ ({ theme: { textColor } }) => textColor };
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
`;

export const RedirectTo = styled(Link)`
    align-items: center;
    box-sizing: border-box;
    color: ${ ({ theme: { textColor } }) => textColor };
    cursor: pointer;
    display: flex;
    height: 20px;
    margin-right: 5px;
    transition: all 0.3s ease;
    
    &:hover {
        text-decoration: none;
        color: ${ ({ theme: { textColor } }) => textColor };
        transform: scale(1.3);
    }

    @media print {
        display: none!important;
    }
`;

export const Title = styled.h1`
    color: ${ ({ theme: { textColor } }) => textColor };
    display: flex;
    flex: 1;
    font-size: 14px;
    font-weight: 400;
    margin: 0;
    @media print {
        display: none!important;
    }
`;
